// extracted by mini-css-extract-plugin
module.exports = {"mapContainer":"map-module--map-container--3TlxT","marker1":"map-module--marker1--1N8E9","marker2":"map-module--marker2--1zmiN","legend":"map-module--legend--1RgP_"};